import { isArray, reduceRight } from 'lodash-es';
import React, { ReactNode, memo } from 'react';

export type NestedProviderWithProps<P extends object = {}> = [React.ComponentType<P>, P];
export type NestedProviderDef = React.ComponentType | NestedProviderWithProps;
export type NestedProviderDefs = Array<NestedProviderDef>;

type NestedProvidersProps = {
  providers: NestedProviderDefs;
  children: ReactNode;
};

const NestedProviders = ({ providers, children }: NestedProvidersProps) => {
  return reduceRight(
    providers,
    (result, provider) => {
      const Provider = (isArray(provider) ? provider[0] : provider) as React.ComponentType<any>;
      const providerProps = isArray(provider) ? provider[1] : {};

      return <Provider {...providerProps}>{result}</Provider>;
    },
    children,
  );
};

NestedProviders.withProps = <P extends object>(
  provider: React.ComponentType<P>,
  props: P,
): NestedProviderWithProps<P> => [provider, props];

export default memo(NestedProviders);
